/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/access-requests
 */
export interface AccessRequestsRequestBuilder extends BaseRequestBuilder<AccessRequestsRequestBuilder> {
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AccessRequestsRequestBuilderUriTemplate = "{+baseurl}/api/analytics/access-requests";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AccessRequestsRequestBuilderNavigationMetadata: Record<Exclude<keyof AccessRequestsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
